import * as SocrataVisualizations from 'common/visualizations';

/**
 * `FlyoutRenderer` is an old-school class, created by definition a function.
 * typescript doesn't like calling `new` on those. Will need to convert that into
 * an actual Class in order to remove this ts-expect-error
 */
// @ts-expect-error FlyoutRenderer needs to be a class
export const flyoutRenderer = new SocrataVisualizations.views.FlyoutRenderer();
export default SocrataVisualizations.views.FlyoutRenderer;
